import { combineReducers } from "redux";
import register from "../features/admin/auth/Slice";

const auth = combineReducers({
  register: register,
});

export default auth;
